// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Abwesenheit, MyAbwesenheitDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateMeineAbwesenheit(): (
  requestBody: MyAbwesenheitDaten
) => Promise<Abwesenheit> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).abwesenheiten.createMeineAbwesenheit({ requestBody }),
    [getAPI]
  );
}
